import * as React from 'react';

import { cn } from '../../lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
  fullWidth?: boolean;
  inputSize?: 'default' | 'xl';
}

const inputSizeClasses: Record<'default' | 'xl', string> = {
  default: '',
  xl: 'h-[46px] rounded-[10px] border-[1.5px] border-auth-border px-4 text-[15px] md:text-[15px]'
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type, fullWidth = false, inputSize = 'default', ...props },
    ref
  ) => {
    return (
      <input
        type={type}
        data-slot='input'
        className={cn(
          // eslint-disable-next-line
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          fullWidth ? 'w-full' : 'w-full sm:w-[350px]',
          inputSizeClasses[inputSize],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
